module.exports = __webpack_public_path__ + "img/421-d01ec1.png";